// Twinkling star field for the space theme. Pure CSS — opacity pulse on
// emoji stars at fixed positions. Honours `prefers-reduced-motion` via
// the shared `.theme-decoration` rule in index.css.
export function Stars() {
  return (
    <div className="theme-decoration theme-decoration-stars" aria-hidden="true">
      <span className="star star-1">⭐</span>
      <span className="star star-2">✨</span>
      <span className="star star-3">⭐</span>
      <span className="star star-4">✨</span>
      <span className="star star-5">⭐</span>
      <span className="star star-6">✨</span>
    </div>
  );
}
